import { MetaData } from '../MetaData';
import { isUndefined } from 'util';
import { TICKET_TYPE } from '../../enums/model.enums';
/**
 * class {Ticket}
 * should be used to describe a type of ticket that can have several different price
 * levels which determine the actual price of the ticket
 */
export class Ticket extends MetaData {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param price
     */
    constructor(id, name, type, validityDuration, description, priceLevels, metaData) {
        super(metaData);
        this._id = id;
        this._name = name;
        this._type = type;
        this._validityDuration = validityDuration;
        this._description = description;
        this._priceLevels = priceLevels;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values Object of values to inflate the object with
     * @returns {Ticket}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.name = values.name || '';
        sanitizedValues.type = !isUndefined(values.type) ? values.type : TICKET_TYPE.SINGLE;
        sanitizedValues.validityDuration = values.validityDuration || 0;
        sanitizedValues.description = values.description || '';
        sanitizedValues.priceLevels = values.priceLevels || [];
        sanitizedValues.metaData = !isUndefined(values.metaData) ? values.metaData : {};
        return new Ticket(sanitizedValues.id, sanitizedValues.name, sanitizedValues.validityDuration, sanitizedValues.type, sanitizedValues.description, sanitizedValues.priceLevels, sanitizedValues.metaData);
    }
    /**
     * gets the internal _id
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the internal _id
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets name for current ticket
     * @returns {string}
     */
    get name() {
        return this._name;
    }
    /**
     * sets name of current ticket
     * @param value
     */
    set name(value) {
        this._name = value;
    }
    /**
     * gets the ticket type
     * @returns {TICKET_TYPE}
     */
    get type() {
        return this._type;
    }
    /**
     * sets the ticket type
     * @param value
     */
    set type(value) {
        this._type = value;
    }
    /**
     * gets validity duration in hours for current ticket
     * @returns {number}
     */
    get validityDuration() {
        return this._validityDuration;
    }
    /**
     * sets validity duration in hours of current ticket
     * @param value
     */
    set validityDuration(value) {
        this._validityDuration = value;
    }
    /**
     * gets description for current ticket
     * @returns {string}
     */
    get description() {
        return this._description;
    }
    /**
     * sets description of current ticket
     * @param value
     */
    set description(value) {
        this._description = value;
    }
    /**
     * gets the availiable price levels for the current ticket
     * @returns {PriceLevel[]}
     */
    get priceLevels() {
        return this._priceLevels;
    }
    /**
     * sets the availiable price levels for the current ticket
     * @param value
     */
    set priceLevels(value) {
        this._priceLevels = value;
    }
}
//# sourceMappingURL=ticket.js.map